<template>
  <v-card flat outlined>
    <v-card-title class="headline text-center d-block">{{ title }}</v-card-title>
    <v-card-text>
      <div class="subtitle-1 text-center">Today</div>
    </v-card-text>

    <v-card
        class="d-flex justify-space-around flex-wrap mb-6`"
        flat
        tile
    >
      <v-card
          v-for="(label, n) in todayLabels"
          :key="n"
          class="pa-2 mb-1 text-center"
          dark
          flat
          :color="['blue','teal','green','orange','red'][n]"
          style="border-radius: 4px !important;"
      >
        <span class="overline" style="text-overflow: ellipsis;">{{label}}</span><br>
        <span class="display-1">{{ getTodayLatest(label) }}</span>
      </v-card>
    </v-card>
    <div class="mt-2 subtitle-1 text-center">Weekly Stats</div>
    <line-chart :title="title" :graph-data="chartData"></line-chart>
  </v-card>
</template>

<script>
    // import {mapGetters} from 'vuex'
    import * as color from './colors'
    import moment from 'moment'
    import LineChart from '../Charts/Line'


    export default {
        components: {LineChart},
        name: 'MessagesCard',
        props: {
            title: String,
            metrics: Object
        },
        data() {
            return {
                todayLabels: [
                    'Received', 'Sent', 'Answered', 'Unanswered', 'Overdue'
                ],
                messageGraphData: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Received',
                            borderColor: 'DEEPSKYBLUE',
                            backgroundColor: 'DEEPSKYBLUE',
                            fill: false,
                            data: [],
                        },
                        {
                            label: 'Send',
                            borderColor: 'TURQUOISE',
                            backgroundColor: 'TURQUOISE',
                            fill: false,
                            data: [],
                        },
                        {
                            label: 'Answered',
                            borderColor: 'SEAGREEN',
                            backgroundColor: 'SEAGREEN',
                            fill: false,
                            data: [],
                        },
                        {
                            label: 'Unanswered',
                            borderColor: 'DARKORANGE',
                            backgroundColor: 'DARKORANGE',
                            fill: false,
                            data: [],
                        },
                        {
                            label: 'Overdue',
                            borderColor: 'CRIMSON',
                            backgroundColor: 'CRIMSON',
                            fill: false,
                            data: [],
                        }
                    ]
                }
            }
        },
        computed: {
            chartData() {
                const labelColor = {
                    'Received': color.TURQUOISE,
                    'Sent': color.BLUE,
                    'Answered': color.GREEN,
                    'Unanswered': color.ORANGE,
                    'Overdue': color.RED,

                }
                let datasets = []
                for (const l in this.todayLabels) {
                    const label = this.todayLabels[l]
                    let dataset = {
                        label: label,
                        borderColor: labelColor[label],
                        backgroundColor: labelColor[label],
                        fill: false,
                        data: this.getDailyGraphData(label),
                        timestamps: this.getDailyGraphTimestamps(label)
                    }
                    datasets.push(dataset)
                }
                // let labels = datasets[0].timestamps.map(t => moment.unix(t).format('MMM Do'))
                let labels = datasets[0].timestamps.map(t => moment.unix(t).format('MMM Do'))
                return {
                    labels: labels,
                    datasets: datasets
                }
            }
        },
        methods: {
            getTodayLatest(label) {
                const metricSlug = label.toLowerCase() + '-messages-today'
                try {
                    const metric = this.metrics[metricSlug]
                    let latest = metric.data.slice(-1)[0]
                    return latest[1]
                } catch (e) {
                    return '-'
                }
            },
            getInstantLatest(label) {
                const metricSlug = label.toLowerCase() + '-messages'
                try {
                    const metric = this.metrics[metricSlug]
                    let latest = metric.data.slice(-1)[0]
                    return latest[1]
                } catch (e) {
                    return 0
                }
            },
            getDailyGraphData(label) {
                const metricSlug = label.toLowerCase() + '-messages-today'
                try {
                    const metric = this.metrics[metricSlug]
                    return metric.data.map(i => i[1])
                } catch (e) {
                    return []
                }
            },
            getDailyGraphTimestamps(label) {
                const metricSlug = label.toLowerCase() + '-messages-today'
                try {
                    const metric = this.metrics[metricSlug]
                    return metric.data.map(i => i[0])
                } catch (e) {
                    return []
                }
            },
        }
    }
</script>